import { useNavigate, generatePath } from 'react-router-dom';
import { useTicketList } from '@base/state/use-tickets';
import { ROUTES } from '../router/route-constants';

export function useTicketListData(incidentId: string) {
  const { data, isLoading, isError, error, refetch } = useTicketList(incidentId);

  return {
    tickets: data || [],
    isLoading,
    isError,
    error,
    refetch,
  };
}

export function useTicketActions() {
  const navigate = useNavigate();

  const viewTicket = (ticketId: string) => {
    navigate(generatePath(ROUTES.DETAIL, { ticketId }));
  };

  const editTicket = (ticketId: string) => {
    navigate(generatePath(ROUTES.EDIT, { ticketId }));
  };

  /**
   * Deletes a defect line via API.
   * NOTE: The CRM API only supports DELETE /defect-line (individual line),
   * not DELETE /field-ticket (entire ticket).
   *
   * @param ticketIdExternal - The ticket's external ID (incident_id)
   * @param defectLineId - The defect line's internal name/ID from API response
   */
  const deleteTicket = (ticketIdExternal: string, defectLineId: string) => {
    // Stub: Delete defect line will be implemented when API supports it.
    // Current API only allows: DELETE /api/method/defect-line
    // with body { ticket_id_external, defect_line_id }
    console.log('Delete defect line:', { ticketIdExternal, defectLineId });
  };

  const createTicket = () => {
    navigate(ROUTES.CREATE);
  };

  return {
    viewTicket,
    editTicket,
    deleteTicket,
    createTicket,
  };
}
